import { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from './ui/dialog';
import { Button } from './ui/button';
import { Clock } from 'lucide-react';

export default function ComingSoon({ url, children, className, title, description }) {
  const [open, setOpen] = useState(false);

  const handleClick = (e) => {
    if (!url) {
      e.preventDefault();
      setOpen(true);
    }
  };

  // Detectar si es una ruta interna (empieza con /)
  const isInternalRoute = url && url.startsWith('/');
  
  // Elegir el componente apropiado
  const Tag = isInternalRoute ? Link : (url ? 'a' : 'button');
  
  // Props según el tipo de componente
  const tagProps = isInternalRoute
    ? { to: url } // React Router Link
    : url
    ? { href: url, target: '_blank', rel: 'noopener noreferrer' } // Enlace externo
    : { onClick: handleClick, type: 'button' }; // Botón que abre modal

  return (
    <>
      <Tag {...tagProps} className={className}>
        {children}
      </Tag>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent
          data-testid="coming-soon"
          className="max-w-sm"
          aria-labelledby="cs-title"
        >
          <DialogHeader>
            <div className="flex justify-center mb-4">
              <div className="w-14 h-14 rounded-2xl bg-[#CFE3F5] flex items-center justify-center">
                <Clock size={26} className="text-[#1E5AA8]" aria-hidden="true" />
              </div>
            </div>
            <DialogTitle id="cs-title" className="text-center font-display text-2xl text-[#0A2540]">
              {title || 'Próximamente disponible'}
            </DialogTitle>
            <DialogDescription className="text-center text-[#6F8AA8] text-sm leading-relaxed">
              {description ||
                'Este contenido estará disponible en una próxima actualización del portal. Contacta con el equipo de Digitalización para más información.'}
            </DialogDescription>
          </DialogHeader>
          <div className="mt-4 flex justify-center">
            <Button
              onClick={() => setOpen(false)}
              className="rounded-full px-8 bg-[#0A2540] text-white hover:bg-[#1E5AA8] transition-colors"
            >
              Cerrar
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
